export default {
    about_the_course: "À propos du cours",
    activity_plural: "Activités",
    activity: "Activité",
    block_general_test: "Test Général 'Bloc'",
    block_test: "Test 'Bloc'",
    blocked: "Bloqué",
    class_plural: "Cours",
    class: "Leçon",
    classes: "Cours",
    comment: "Commentaire",
    congratulations: "Toutes nos félicitations!",
    continue: "En développement",
    conventional_test: "Test 'Conventionnel'",
    discussions_about_this_course: "Discussions sur ce cours",
    doubts: "Les doutes?",
    end_quiz: "Fin du quiz",
    enroll: "Inscrire",
    enrolled: "Inscrit",
    enrollement_type: "Type d'inscription",
    evaluated_quiz: "Quiz avec évaluation",
    finish_test: "Dernier",
    flash: "Flash",
    html: "HTML",
    if_you_are_not_approved_within_the_available_attempts_you_will_have_your_progress_restarted: "Si vous n'êtes pas approuvé dans les tentatives disponibles, votre progression sera redémarrée.",
    if_you_fail_the_available_attempts_you_will_be_blocked_in_this_training: "Si vous échouez aux tentatives disponibles, vous serez bloqué dans cette formation.",
    if_you_pass_you_can_use_the_remaining_attempts_to_try_to_improve_your_grade: "Si vous réussissez, vous pouvez utiliser les tentatives restantes pour essayer d'améliorer votre note.",
    improved: "Améliorée",
    in_this_course: "dans ce cours",
    keep_trying: "Continue d'essayer.",
    loading_courses: "Chargement des cours",
    mandatory: "Obligatoire",
    maximum_attempts: "Maximal de tentatives",
    minimum_to_pass: "Minimum pour réussir",
    next_question: "Suivante",
    previous_question: "Précédente",
    no_courses_are_available_at_the_moment: "Aucun cours n'est actuellement disponible",
    no_courses_are_available_with_the_selected_filter: "Il n'y a pas de cours disponibles pour le filtre sélectionné",
    not_started: "Pas commencé",
    number_of_questions: "Nombre de questions",
    of_attempts: "{qty_attempted} de {maximum_attempts} tentatives",
    of_questions: "{minimum_score} des {qty_questions} questions",
    once_you_start_the_test_you_should_not_change_activity_leave_or_refresh_the_page: "Lors du démarrage du test, vous ne devez pas modifier votre activité, quitter ou mettre à jour la page.",
    one_attempt: "Un essai",
    overview: "Tableau de Bord",
    powerpoint: "PowerPoint",
    presentation: "Présentation",
    previous_results: "Résultats précédents",
    question_plural: "Questions",
    question: "Question",
    reproved: "Réprouver",
    restart_general_test: "Test Général 'Réinitialiser'",
    restart_test: "Test 'Réinitialiser'",
    restart_training: "Recommencer la formation",
    restarted: "Redémarré",
    scorm: "Activité",
    see_previous_results: "Afficher les résultats précédents",
    see_results: "Voir les résultats",
    see_answers: "Voir les réponses",
    slideshare: "Slideshare",
    start_quiz: "Démarrer le quiz",
    start_test: "Lancer le test",
    start: "Début",
    support_material_preview: "Aperçu du matériel de support",
    support_materials: "Matériels de Soutien",
    test_performance: "Performances des tests",
    thank_you_for_taking_the_quiz: "Merci d'avoir répondu au quiz",
    that_was_close: "C'était fermé!",
    the_result_of_this_quiz_will_not_influence_the_final_result_of_your_training: "Le résultat de ce quiz n'influencera pas le résultat final de votre formation.",
    time_left: "Temps restant",
    time_to_finish: "Il est temps de terminer",
    unenroll: "Dématrulez-vous",
    unevaluated_quiz: "Quiz sans évaluation",
    unlimited: "Illimité",
    until_approval: "Jusqu'à approbation",
    video: "Vidéo",
    view_history: "voir l'historique",
    when_starting_the_quiz_you_should_not_change_your_activity_leave_or_update_the_page: "Lorsque vous lancez le quiz, vous ne devez pas modifier votre activité, quitter ou mettre à jour la page.",
    you_are_allowed_to_take_this_test_how_many_times_you_like_until_you_reach_the_minimum_score_to_pass: "Vous pouvez passer ce test autant de fois que vous le souhaitez jusqu'à ce que vous atteigniez le score minimum à réussir.",
    you_can_take_this_quiz_as_many_times_as_needed_and_you_will_need_to_get_out_of_questions_to_pass: "Vous pouvez répondre à ce quiz autant de fois que nécessaire et vous devrez retirer {minimum_score} des {qty_questions} questions à passer.",
    you_can_take_this_quiz_only_once_to_answer_as_many_questions_as_possible: "Vous ne pouvez répondre à ce quiz qu'une seule fois pour répondre à autant de questions que possible.",
    you_can_take_this_test_only_once_with_a_timeout_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test: "Vous ne pouvez répondre à ce test qu'une seule fois avec le délai d'expiration {time_to_answer} pour atteindre le score minimum à réussir. Vous devrez obtenir {minimum_score} des {qty_questions} questions pour réussir ce test.",
    you_can_take_this_test_up_to_times_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test: "Vous pouvez passer ce test jusqu'à {maximum_attempts} fois pour atteindre le score minimum à réussir. Vous devrez obtenir {minimum_score} des {qty_questions} questions pour réussir ce test.",
    you_got_out_of_questions_right_success_rate_and_you_showed_that_you_understand_a_lot_keep_it_up_and_show_that_you_are_the_one_who_dominates_this_subject: "Vous avez obtenu {score} sur {questions} questions ({percent}%) et montré que vous comprenez beaucoup! Continuez et montrez que vous êtes celui qui domine ce sujet!",
    you_got_out_of_questions_successful_and_you_didnt_reach_the_minimum_score_to_pass: "Vous avez atteint {score} sur {questions} ({percent}% de réussite) et n'avez pas atteint la note de passage minimale ({minimum_score}% de réussite).",
    you_did_not_reach_the_minimum_score_to_pass_try_again_to_complete_the_course: "Vous n'avez pas atteint la note minimale pour réussir. Réessayez pour terminer le cours !",
    you_did_not_reach_the_minimum_score_to_pass: "Vous n'avez pas atteint la note minimale pour réussir.",
    you_got_out_of_success: "Vous avez obtenu {score} sur {questions} ({percent}% de réussite).",
    you_have_already_answered_this_test_times_and_have_attempt_left: "Vous avez déjà effectué ce test {qty_attempted} fois et il vous reste {attempts_left}.",
    you_have_been_blocked_in_this_course_and_will_not_receive_a_certificate: "Vous avez été bloqué dans ce cours et ne recevrez pas de certificat",
    you_have_been_blocked_in_this_training_and_will_not_receive_a_certificate_you_can_still_finish_the_other_available_activities: "Vous avez été bloqué dans cette formation et ne recevrez pas de certificat. Vous pouvez toujours terminer les autres activités disponibles.",
    you_have_been_blocked: "Vous avez été bloqué",
    you_have_only_one_attempt_to_pass_and_will_be_blocked_from_this_training_if_you_fail: "Vous n'avez qu'une seule tentative de réussite et serez bloqué de cette formation si vous échouez.",
    you_have_only_one_attempt_to_pass_and_will_have_your_progress_restarted_in_this_training_if_you_fail: "Vous n'avez qu'une seule tentative de réussite et votre progression sera reprise dans cette formation si vous échouez.",
    you_need_to_enroll_before_starting_this_content: "Vous devez vous inscrire avant de commencer ce contenu",
    you_need_to_enroll_before_starting_this_course: "Vous devez vous inscrire avant de commencer ce cours",
    you_need_to_finish_another_course_before_starting_this: "Vous devez terminer un autre cours avant de commencer",
    you_need_to_get_of_questions_right_to_be_approved: "Vous devez obtenir {minimum_score} des {qty_questions} questions pour réussir ce test.",
    your_progress_has_been_restarted_and_you_will_need_to_redo_all_activities_in_this_training_to_receive_the_certificate: "Votre progression a été redémarrée et vous devrez refaire toutes les activités de cette formation pour recevoir le certificat.",
    your_progress_has_been_restarted: "Votre progression a été redémarrée",
    you_have_been_reproved_and_reached_the_maximum_attempts_restart_training: "Vous avez été refusé et avez atteint le nombre maximum de tentatives sans approbation. Votre formation a été redémarrée, refaites toutes les activités précédentes pour réessayer.",
    your_result: "Ton résultat",
    your_status: "Votre statut",
    training_in_progress: 'Cours en cours de développement par le gestionnaire',
    video_issue_ios_message: 'Vous avez du mal à regarder la vidéo ? Pas de souci ! Appuyez sur le bouton ci-dessous pour l\'ouvrir dans le navigateur de votre téléphone.',
    watch_in_browser: 'Regarder dans le navigateur',
}
